import { render, staticRenderFns } from "./ButtonEl.vue?vue&type=template&id=3765606b&"
import script from "./ButtonEl.vue?vue&type=script&lang=js&"
export * from "./ButtonEl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports